import React, { useState } from 'react';

const Footer = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus({ ok: false, text: 'Please fill all fields.' });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), message: message.trim() }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus({ ok: true, text: 'Feedback sent. Thank you!' });
        setName('');
        setEmail('');
        setMessage('');
      } else {
        setStatus({ ok: false, text: data.message || 'Failed to send feedback.' });
      }
    } catch (err) {
      console.error('Feedback send error:', err);
      setStatus({ ok: false, text: 'Network error. Try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 text-gray-700 py-16 mt-12 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-8">
          {/* Contact Information */}
          <div className="md:col-span-3 flex flex-col space-y-4">
            <div className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                Contact Us
              </h4>
              {/* Changed from indigo-600 */}
              <p className="text-lg font-semibold text-[#fc9e11]">+20 1017844312</p>
              <p className="text-gray-600 mt-2">24/7 Customer Support</p>
              <div className="mt-6 flex space-x-4">
                {/* Changed from indigo-600 */}
                <a href="#" className="text-gray-400 hover:text-[#fc9e11] transition-colors duration-300">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
                  </svg>
                </a>
                {/* Changed from indigo-600 */}
                <a href="#" className="text-gray-400 hover:text-[#fc9e11] transition-colors duration-300">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.411 2.865 8.138 6.839 9.439.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.604-3.369-1.34-3.369-1.34-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.137 20.136 22 16.411 22 12c0-5.523-4.477-10-10-10z"/>
                  </svg>
                </a>
                {/* Changed from indigo-600 */}
                <a href="#" className="text-gray-400 hover:text-[#fc9e11] transition-colors duration-300">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-xl font-bold text-gray-900 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                {/* Changed from indigo-600 */}
                <a href="/" className="text-gray-600 hover:text-[#fc9e11] transition-colors duration-300 flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                  </svg>
                  Home
                </a>
              </li>
              <li>
                {/* Changed from indigo-600 */}
                <a href="/tech" className="text-gray-600 hover:text-[#fc9e11] transition-colors duration-300 flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                  Tech Collection
                </a>
              </li>
              <li>
                {/* Changed from indigo-600 */}
                <a href="/women" className="text-gray-600 hover:text-[#fc9e11] transition-colors duration-300 flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                  </svg>
                  Arab Collection
                </a>
              </li>
              <li>
                {/* Changed from indigo-600 */}
                <a href="/categories" className="text-gray-600 hover:text-[#fc9e11] transition-colors duration-300 flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
                  </svg>
                  All Categories
                </a>
              </li>
            </ul>
          </div>

          {/* Feedback Form */}
          <div className="md:col-span-6">
            <div className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
              <h4 className="text-xl font-bold text-gray-900 mb-4">Send Feedback</h4>
              <p className="text-gray-600 mb-6">We value your feedback! Let us know how we can improve your shopping experience.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name"
                    // Changed from indigo-500
                    className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#fc9e11] focus:border-transparent transition-all duration-300"
                    aria-label="Your name"
                  />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.targe.value)}
                    placeholder="Your email"
                    // Changed from indigo-500
                    className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#fc9e11] focus:border-transparent transition-all duration-300"
                    aria-label="Your email"
                  />
                </div>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Your message"
                  rows={4}
                  // Changed from indigo-500
                  className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#fc9e11] focus:border-transparent transition-all duration-300"
                  aria-label="Your message"
                />
                <div className="flex items-center">
                  <button
                    type="submit"
                    disabled={loading}
                    // Changed from indigo to orange, and text-white to text-black
                    className="bg-[#fc9e11] text-black font-semibold px-6 py-3 rounded-lg hover:bg-[#c97900] focus:ring-4 focus:ring-orange-200 transition duration-300 disabled:opacity-60 flex items-center"
                  >
                    {loading ? (
                      <>
                        {/* Changed spinner text to black */}
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                  {status && (
                    <p className={`ml-4 text-sm ${status.ok ? 'text-green-600' : 'text-red-600'} animate-fade-in`}>
                      {status.text}
                    </p>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} ArabTech. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Making online shopping easier and more accessible for everyone.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;